import { fullWidth5050Image } from "@/helpers/builder-init/5050ImageFullWidth";
import { productSystemsInit } from "@/helpers/builder-init/ProductSystems";
import { cardBannerInit } from "@/helpers/builder-init/CardBanner";
import { testimonialInit } from "@/helpers/builder-init/testimonial";
import { featuredContentInit } from "@/helpers/builder-init/FeaturedContent";
import { specSheetInit } from "@/helpers/builder-init/SpecSheet";
import { textPanelsInit } from "@/helpers/builder-init/TextColumns";
import { faqInit } from "@/helpers/builder-init/FaqBuilderInit";
export const registeredComponents = [
    fullWidth5050Image,
    productSystemsInit,
    cardBannerInit,
    testimonialInit,
    featuredContentInit,
    specSheetInit,
    textPanelsInit,
    faqInit,
];